/**
 * SmartClock roles (mirror of SMARTCLOCK_API src/config/roles.js).
 *
 * The BackOffice is the administration/support console of the platform:
 * only `providerAdmin` accounts may enter. The API is the authority for
 * authorization; guards and hidden actions are defense-in-depth only.
 */

export type Role =
  'worker' | 'supervisor' | 'hr' | 'companyAdmin' | 'providerAdmin' | 'external' | 'inspector';

/** Roles allowed to use the BackOffice console. */
export const BACKOFFICE_ROLES: readonly Role[] = ['providerAdmin'] as const;

/** Spanish UI label per role. */
export const ROLE_LABEL: Record<Role, string> = {
  worker: 'Trabajador',
  supervisor: 'Supervisor',
  hr: 'RRHH',
  companyAdmin: 'Administrador de Empresa',
  providerAdmin: 'Administrador del Proveedor',
  external: 'Empresa Externa',
  inspector: 'Fiscalizador DT',
};
